
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Axios from "axios";
import AkkhorLayout from "../layout/akkhor";
import AlertErrorForm from "../component/AlertErrorForm";
import { URL_LIST_ALL } from "../configs/api";
import { confirmAlert } from "react-confirm-alert";
import Spinner from "../component/Spinner";
import SearchBoxModal from "../component/SearchBoxModal";
import ChonCauHoiModal from "./ChonCauHoiModal";
import { Modal } from "react-bootstrap";
import CauHoiRenderer from "./CauHoiRenderer";

const LOAI_LABEL = {
    single: "Trắc nghiệm 1 đáp án",
    multiple: "Trắc nghiệm nhiều đáp án",
    sort: "Sắp xếp vị trí",
    match: "Nối cột",
    essay: "Tự luận",
};

export default function FormDeThi() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [detail, setDetail] = useState(null);
    const [loading, setLoading] = useState(false);
    const [chamMode, setChamMode] = useState('auto_chia_deu');
    const [tongDiem, setTongDiem] = useState(10);
    const [listCauHoi, setListCauHoi] = useState([]); // [{dethi_cauhoi_id, cauhoi_id, title, loai, diem, position}]
    const [reloadCau, setReloadCau] = useState(false);
    const [showChonCauHoi, setShowChonCauHoi] = useState(false);
    const [addingBulk, setAddingBulk] = useState(false);
    // Người tham gia: [{id, name}] cho user và part. Trống = tất cả.
    const [participantUsers, setParticipantUsers] = useState([]);
    const [participantParts, setParticipantParts] = useState([]);
    const [resetUserBox, setResetUserBox] = useState(0);
    const [resetPartBox, setResetPartBox] = useState(0);
    // Làm thử đề (giáo viên xem trải nghiệm học sinh)
    const [showLamThu, setShowLamThu] = useState(false);
    const [lamThuData, setLamThuData] = useState(null);
    const [lamThuAnswers, setLamThuAnswers] = useState({});
    const [lamThuLoading, setLamThuLoading] = useState(false);

    // Load đề + danh sách câu hỏi đã gán
    const loadCauHoi = () => {
        if (id > 0) {
            Axios.get(URL_LIST_ALL + "learninghub_dethi_cauhoi?dethi_id=" + id + "&orderby=position-asc&limit=200", user.config)
                .then((res) => {
                    if (res.data.status === "success") {
                        setListCauHoi(res.data.data.map(r => ({
                            dethi_cauhoi_id: r.id,
                            cauhoi_id: r.cauhoi_id,
                            title: r.cauhoi_title,
                            loai: r.cauhoi_loai,
                            diem: r.diem,
                            position: r.position,
                        })));
                    } else console.log(res.data.message);
                }).catch(err => console.log(err));
        }
    };

    useEffect(function () {
        if (id > 0) {
            setLoading(true);
            Axios.get(URL_LIST_ALL + "learninghub_dethi/" + id, user.config)
                .then((res) => {
                    setLoading(false);
                    if (res.data.status === "success") {
                        const d = res.data.data;
                        setDetail(d);
                        setChamMode(d.cham_diem_mode || 'auto_chia_deu');
                        setTongDiem(d.tong_diem != null ? d.tong_diem : 10);
                        resolveParticipants(d.participant_users || [], d.participant_parts || []);
                    } else console.log(res.data.message);
                }).catch(err => { console.log(err); setLoading(false); });
        }
    }, [user, id]);// eslint-disable-line

    // Lấy tên cho các id người tham gia đã lưu (để hiển thị chip)
    const resolveParticipants = (userIds, partIds) => {
        const cfgName = (col) => ({ headers: { ...user.config.headers, asselect: JSON.stringify(['id as value', col + ' as label']) } });
        userIds.forEach((uid) => {
            Axios.get(URL_LIST_ALL + 'users?id=' + uid, cfgName('fullname')).then((res) => {
                const row = res.data.status === 'success' && res.data.data && res.data.data[0];
                if (row) setParticipantUsers((prev) => prev.find(x => x.id === row.value) ? prev : [...prev, { id: row.value, name: row.label }]);
            }).catch(e => console.log(e));
        });
        partIds.forEach((pid) => {
            Axios.get(URL_LIST_ALL + 'parts?id=' + pid, cfgName('title')).then((res) => {
                const row = res.data.status === 'success' && res.data.data && res.data.data[0];
                if (row) setParticipantParts((prev) => prev.find(x => x.id === row.value) ? prev : [...prev, { id: row.value, name: row.label }]);
            }).catch(e => console.log(e));
        });
    };

    useEffect(loadCauHoi, [user, id, reloadCau]);// eslint-disable-line

    const formik = useFormik({
        initialValues: detail ? detail : { title: '', mota: '', loai: 'kiemtra', course_id: null, baigiang_id: null, thoi_gian: '', status: 1 },
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            title: Yup.string().trim().nullable().required('Vui lòng nhập tiêu đề'),
        }),
        onSubmit: (values) => {
            const payload = {
                ...values,
                cham_diem_mode: chamMode,
                tong_diem: tongDiem,
                thoi_gian: values.thoi_gian === '' ? null : values.thoi_gian,
                participant_users: participantUsers.map(u => u.id),
                participant_parts: participantParts.map(p => p.id),
            };
            setLoading(true);
            const done = (res) => {
                setLoading(false);
                if (res.data.status === "success") {
                    if (id > 0) window.location.reload();
                    else window.location.href = '/edit-learninghub_dethi/' + res.data.id;
                } else confirmAlert({ title: 'Lỗi', message: res.data.message, buttons: [{ label: 'OK' }] });
            };
            if (id > 0) Axios.put(URL_LIST_ALL + 'learninghub_dethi/' + id, payload, user.config).then(done).catch(err => { console.log(err); setLoading(false); });
            else Axios.post(URL_LIST_ALL + 'learninghub_dethi', payload, user.config).then(done).catch(err => { console.log(err); setLoading(false); });
        },
    });

    // Điểm chia đều khi mode = auto_chia_deu
    const diemChiaDeu = listCauHoi.length > 0 ? (Number(tongDiem) / listCauHoi.length) : 0;

    // Thêm nhiều câu hỏi cùng lúc (tuần tự để position tăng đúng, bỏ qua câu đã có)
    const addNhieuCauHoi = async (ids) => {
        const existing = new Set(listCauHoi.map(c => String(c.cauhoi_id)));
        const toAdd = (ids || []).filter(cid => !existing.has(String(cid)));
        setShowChonCauHoi(false);
        if (toAdd.length === 0) return;
        setAddingBulk(true);
        let position = listCauHoi.length;
        for (const cauhoi_id of toAdd) {
            position += 1;
            try {
                await Axios.post(URL_LIST_ALL + 'learninghub_dethi_cauhoi',
                    { dethi_id: id, cauhoi_id, position, diem: chamMode === 'thu_cong' ? 1 : null }, user.config);
            } catch (err) { console.log(err); }
        }
        setAddingBulk(false);
        setReloadCau(r => !r);
    };

    const removeCauHoi = (dethi_cauhoi_id) => {
        Axios.delete(URL_LIST_ALL + 'learninghub_dethi_cauhoi/' + dethi_cauhoi_id, user.config)
            .then((res) => { if (res.data.status === "success") setReloadCau(r => !r); }).catch(err => console.log(err));
    };

    const updateDiemCau = (dethi_cauhoi_id, diem) => {
        Axios.put(URL_LIST_ALL + 'learninghub_dethi_cauhoi/' + dethi_cauhoi_id, { diem }, user.config).catch(err => console.log(err));
    };
    const updatePositionCau = (dethi_cauhoi_id, position) => {
        Axios.put(URL_LIST_ALL + 'learninghub_dethi_cauhoi/' + dethi_cauhoi_id, { position }, user.config)
            .then((res) => { if (res.data.status === "success") setReloadCau(r => !r); }).catch(err => console.log(err));
    };

    // Làm thử đề: lấy đề như học sinh (ẩn đáp án) để giáo viên trải nghiệm — KHÔNG lưu/chấm thật.
    const openLamThu = () => {
        setLamThuAnswers({});
        setLamThuData(null);
        setShowLamThu(true);
        setLamThuLoading(true);
        Axios.get(URL_LIST_ALL + "learninghub_lambai?dethi_id=" + id, user.config)
            .then((res) => {
                setLamThuLoading(false);
                if (res.data.status === "success") setLamThuData(res.data.data);
                else confirmAlert({ title: 'Lỗi', message: res.data.message, buttons: [{ label: 'OK' }] });
            })
            .catch((err) => { console.log(err); setLamThuLoading(false); });
    };
    const setLamThuAnswer = (cauhoi_id, val) => setLamThuAnswers((p) => ({ ...p, [cauhoi_id]: val }));

    return (
        <AkkhorLayout idrole="learninghub_dethi">
            <div className="breadcrumbs-area">
                <ul>
                    <li><Link to="/">Trang chủ</Link></li>
                    <li><Link to="/learninghub_dethi">Bài kiểm tra / Bài tập</Link></li>
                    <li>{id > 0 ? 'Sửa đề' : 'Tạo đề'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-5">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title"><h3>{id > 0 ? 'Sửa' : 'Tạo'} bài kiểm tra / bài tập</h3></div>
                    </div>
                    <form className="new-added-form form-info" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12 col-sm-6 form-group">
                                <label>Tiêu đề <span className="text-danger">*</span></label>
                                <input type="text" placeholder="VD: Kiểm tra cuối khóa" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>
                            <div className="col-12 col-sm-3 form-group">
                                <label>Loại</label>
                                <select className="form-select height32" {...formik.getFieldProps("loai")}>
                                    <option value="kiemtra">Bài kiểm tra</option>
                                    <option value="baitap">Bài tập về nhà</option>
                                </select>
                            </div>
                            <div className="col-12 col-sm-3 form-group">
                                <label>Thời gian làm (phút)</label>
                                <input type="number" placeholder="Để trống = không giới hạn" className="form-control height32" {...formik.getFieldProps("thoi_gian")} autoComplete="off" />
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Khóa học (tùy chọn)</label>
                                <SearchBoxModal apiname={"learninghub_khoahoc"} alldata={"?status=1"} placeholder="Chọn khóa học" colvalue={'id'} colname={'title'} name='course_id' defaultValue={formik.values['course_id']}
                                    onChange={(e) => formik.setFieldValue('course_id', e || null)}></SearchBoxModal>
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Bài giảng (tùy chọn)</label>
                                <SearchBoxModal apiname={"learninghub_baigiang"} alldata={"?status=1"} placeholder="Chọn bài giảng" colvalue={'id'} colname={'title'} name='baigiang_id' defaultValue={formik.values['baigiang_id']}
                                    onChange={(e) => formik.setFieldValue('baigiang_id', e || null)}></SearchBoxModal>
                            </div>
                            <div className="col-12 form-group">
                                <label>Mô tả</label>
                                <textarea placeholder="Mô tả / hướng dẫn làm bài" className="form-control" {...formik.getFieldProps("mota")}></textarea>
                            </div>

                            <div className="col-12 form-group">
                                <label>Người tham gia</label>
                                <div className="alert alert-secondary py-2 mb-2">Để trống = <strong>tất cả</strong> đều được làm. Chọn nhân sự và/hoặc phòng ban để giới hạn đối tượng.</div>
                                <div className="row">
                                    <div className="col-12 col-sm-6">
                                        <small className="text-muted">Thêm nhân sự</small>
                                        <SearchBoxModal apiname={"users"} placeholder="Chọn nhân sự" colvalue={'id'} colname={'fullname'} name='add_user' resetKey={resetUserBox} buttonLabel="Thêm"
                                            onChange={(val) => {
                                                if (!val) return;
                                                setParticipantUsers((prev) => prev.find(x => String(x.id) === String(val)) ? prev : [...prev, { id: Number(val), name: '' }]);
                                            }}
                                            onLabel={(lbl) => setParticipantUsers((prev) => prev.map(x => x.name === '' ? { ...x, name: lbl } : x))}
                                        ></SearchBoxModal>
                                        <div className="mt-2">
                                            {participantUsers.map((u) => (
                                                <span key={u.id} className="badge badge-info mr-1 mb-1" style={{ fontSize: 13 }}>
                                                    {u.name || ('#' + u.id)} <span className="fas fa-times ml-1" style={{ cursor: 'pointer' }} onClick={() => { setParticipantUsers(participantUsers.filter(x => x.id !== u.id)); setResetUserBox(k => k + 1); }}></span>
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <small className="text-muted">Thêm phòng ban</small>
                                        <SearchBoxModal apiname={"parts"} placeholder="Chọn phòng ban" colvalue={'id'} colname={'title'} name='add_part' resetKey={resetPartBox} buttonLabel="Thêm"
                                            onChange={(val) => {
                                                if (!val) return;
                                                setParticipantParts((prev) => prev.find(x => String(x.id) === String(val)) ? prev : [...prev, { id: Number(val), name: '' }]);
                                            }}
                                            onLabel={(lbl) => setParticipantParts((prev) => prev.map(x => x.name === '' ? { ...x, name: lbl } : x))}
                                        ></SearchBoxModal>
                                        <div className="mt-2">
                                            {participantParts.map((p) => (
                                                <span key={p.id} className="badge badge-success mr-1 mb-1" style={{ fontSize: 13 }}>
                                                    {p.name || ('#' + p.id)} <span className="fas fa-times ml-1" style={{ cursor: 'pointer' }} onClick={() => { setParticipantParts(participantParts.filter(x => x.id !== p.id)); setResetPartBox(k => k + 1); }}></span>
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 form-group">
                                <label>Cách tính điểm</label>
                                <select className="form-select height32" value={chamMode} onChange={(e) => setChamMode(e.target.value)}>
                                    <option value="auto_chia_deu">Tổng điểm chia đều cho các câu</option>
                                    <option value="thu_cong">Nhập điểm thủ công từng câu</option>
                                </select>
                            </div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Tổng điểm</label>
                                <input type="number" step="0.1" className="form-control height32" value={tongDiem} onChange={(e) => setTongDiem(e.target.value)} autoComplete="off" />
                                {chamMode === 'auto_chia_deu' && listCauHoi.length > 0 &&
                                    <small className="text-info">Mỗi câu: {diemChiaDeu.toFixed(2)} điểm</small>}
                            </div>

                            <div className="col-12 form-group mt-3">
                                <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu thông tin đề</>}</button>
                            </div>
                        </div>
                    </form>

                    {/* ===== Danh sách câu hỏi trong đề (chỉ khi đã lưu đề) ===== */}
                    {id > 0 &&
                        <div className="w-100 mt-4">
                            <hr />
                            <div className="d-flex align-items-center mb-3" style={{ gap: 12 }}>
                                <button type="button" className="btn btn-success" onClick={() => setShowChonCauHoi(true)} disabled={addingBulk}>
                                    {addingBulk ? <Spinner /> : <><span className="fas fa-plus"></span> Thêm câu hỏi từ ngân hàng</>}
                                </button>
                                {listCauHoi.length > 0 &&
                                    <button type="button" className="btn btn-info" onClick={openLamThu}>
                                        <span className="far fa-eye"></span> Làm thử đề
                                    </button>}
                                <Link to={"/theo-doi-lam-bai/" + id} className="btn btn-primary">
                                    <span className="fas fa-broadcast-tower"></span> Theo dõi realtime
                                </Link>
                            </div>

                            <h4>Câu hỏi trong đề ({listCauHoi.length})</h4>
                            {listCauHoi.length === 0 && <div className="alert alert-warning">Chưa có câu hỏi nào. Hãy thêm từ ngân hàng câu hỏi.</div>}
                            {listCauHoi.length > 0 &&
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th style={{ width: 60 }}>STT</th>
                                            <th>Nội dung</th>
                                            <th style={{ width: 160 }}>Loại</th>
                                            <th style={{ width: 120 }}>Điểm</th>
                                            <th style={{ width: 120 }}>Thao tác</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listCauHoi.map((c, idx) => (
                                            <tr key={c.dethi_cauhoi_id}>
                                                <td>
                                                    <input type="number" className="form-control form-control-sm height32" defaultValue={c.position} style={{ width: 60 }}
                                                        onBlur={(e) => updatePositionCau(c.dethi_cauhoi_id, e.target.value)} />
                                                </td>
                                                <td><div className="text-truncate" style={{ maxWidth: 420 }} dangerouslySetInnerHTML={{ __html: c.title }} /></td>
                                                <td>{LOAI_LABEL[c.loai] || c.loai}</td>
                                                <td>
                                                    {chamMode === 'auto_chia_deu'
                                                        ? <span>{diemChiaDeu.toFixed(2)}</span>
                                                        : <input type="number" step="0.1" className="form-control form-control-sm height32" defaultValue={c.diem != null ? c.diem : 1}
                                                            onBlur={(e) => updateDiemCau(c.dethi_cauhoi_id, e.target.value)} />}
                                                </td>
                                                <td>
                                                    <button type="button" className="btn btn-sm btn-danger" onClick={() => removeCauHoi(c.dethi_cauhoi_id)}><span className="fas fa-trash"></span></button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            }
                        </div>
                    }
                </div>
            </div>

            <ChonCauHoiModal
                show={showChonCauHoi}
                onHide={() => setShowChonCauHoi(false)}
                existingIds={listCauHoi.map(c => c.cauhoi_id)}
                onConfirm={addNhieuCauHoi}
            />

            <Modal show={showLamThu} onHide={() => setShowLamThu(false)} size="lg" centered scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>Làm thử đề — giao diện học sinh</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="alert alert-secondary py-2">Đây là chế độ làm thử cho giáo viên kiểm tra đề. Câu trả lời <strong>không được lưu hay chấm điểm</strong>.</div>
                    {lamThuLoading && <div className="w-100 text-center py-3"><Spinner /></div>}
                    {lamThuData &&
                        <>
                            <div className="small text-muted mb-3">Số câu: {lamThuData.so_cau} · Tổng điểm: {lamThuData.tong_diem}{lamThuData.thoi_gian ? ' · Thời gian: ' + lamThuData.thoi_gian + ' phút' : ''}</div>
                            {(lamThuData.list_cauhoi || []).map((c, idx) => (
                                <div className="border rounded p-3 mb-3" key={c.cauhoi_id}>
                                    <div className="d-flex justify-content-between">
                                        <strong>Câu {idx + 1}</strong>
                                        <span className="badge badge-light">{c.diem_hien_thi} điểm</span>
                                    </div>
                                    <div className="mt-1 mb-2" dangerouslySetInnerHTML={{ __html: c.title }} />
                                    <CauHoiRenderer
                                        cauhoi={c}
                                        value={lamThuAnswers[c.cauhoi_id]}
                                        onChange={(v) => setLamThuAnswer(c.cauhoi_id, v)}
                                    />
                                </div>
                            ))}
                        </>}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => setShowLamThu(false)}>Đóng</button>
                </Modal.Footer>
            </Modal>
        </AkkhorLayout>
    );
}
